import Vue from "vue";

const transformer = ({ validation, comment, supplies }) => ({
  resident_validation: validation,
  comment,
  supplies: supplies && supplies.map((s) => {
    return { id: s.id, entryReal: +s.totalEntries };
  }),
});

export default (purchaseOrderFolio, confirmationData) => {
  return Vue.$http
    .post(`/iwarehouse/approve-entry/${purchaseOrderFolio}/`, transformer(confirmationData))
    .then((response) => response.data);
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/sendTransferEntry.js